const APP_ACTION_TYPES = {
    LOAD_INITIAL_STATE: 'LOAD_INITIAL_STATE',
    UPDATE_DATA_COMPONENT_LOCAL_STATE: 'UPDATE_DATA_COMPONENT_LOCAL_STATE',
    REMOVE_DATA_COMPONENT: 'REMOVE_DATA_COMPONENT',
    ADD_DATA_COMPONENT: 'ADD_DATA_COMPONENT',
    OPEN_CONNECT_COMPONENTS: 'OPEN_CONNECT_COMPONENTS',
    CLOSE_CONNECT_COMPONENTS: 'CLOSE_CONNECT_COMPONENTS',
    ADD_ARROW: 'ADD_ARROW',
    REMOVE_ARROW: 'REMOVE_ARROW',
    MODIFY_COMPONENT_DATA: 'MODIFY_COMPONENT_DATA',
    ADD_SOURCE_OUTPUT_REFS: 'ADD_SOURCE_OUTPUT_REFS',
    TOGGLE_IS_DRAGGING: 'TOGGLE_IS_DRAGGING',
    TOGGLE_IS_DRAGGING_DISABLED: 'TOGGLE_IS_DRAGGING_DISABLED',
    REMOVE_ALL: 'REMOVE_ALL',
    UPDATE_DEFAULT_COORDINATES: 'UPDATE_DEFAULT_COORDINATES',
    UPDATE_COMPONENT_LAST_COORDINATES: 'UPDATE_COMPONENT_LAST_COORDINATES',
    SHOW_ALL_TABLES: 'SHOW_ALL_TABLES',
    HIDE_ALL_TABLES: 'HIDE_ALL_TABLES',
    // RESET_SHOW_HIDE_ALL_TABLES: 'RESET_SHOW_HIDE_ALL_TABLES',
    TOGGLE_COMPONENT_SHOW_TABLE: 'TOGGLE_COMPONENT_SHOW_TABLE'
};

export default APP_ACTION_TYPES;